import { Component, Prop, h, State, Host } from '@stencil/core';
import '../header-component/header-component';
import '../loader-component/loader-component'


/**
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/hero-component.PNG)

#### Content Type
nypwebc_ct_tiles
*/


@Component({
  tag: 'hero-component',
  styleUrl: 'hero-component.css',
  //  scoped: true
  shadow: true
})
export class HeroComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";



  /**
*Optional - is it SP Online site
*/
  @Prop() online: boolean = false;

  /**
   *Required - site url if its sp online site
   */
  @Prop() siteurl: string = "";




  @State() items: []
  @State() isLoading: boolean = true;

  componentDidLoad() {
    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;
    // let siteUrl: string = "";

    // if (this.online) {
    //   siteUrl = this.siteurl + this.webpath
    // }
    // else {
    //   siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    // }

    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }

    const filter = "nypwebc_Active eq 1";
    return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_ItemOrder,nypwebc_Url,nypwebc_ImageUrl&$filter=" + filter + "&$Top=5&$orderby=nypwebc_ItemOrder&", { headers: { "Accept": "application/json; odata=verbose" } })

      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.isLoading = false;
      });
  }

  getContentsV2 = () => {
    const contentsArray = []


    console.log(this.items.length);


    this.items.forEach((item: any, index: any) => {

      let classname = "item" + index

      let wrappercss = "image-first"
      if (index !== 0) {
        wrappercss = "image-rest"
      }
      contentsArray.push(

        <div class={classname}>
          <a href={item.nypwebc_Url} target= "_blank"  data-interception="off">
            <div class={wrappercss}>
              <img src={item.nypwebc_ImageUrl} />
              <div class="bottom-left">
                <h3>{item.Title}</h3>
              </div>
            </div>
          </a>
        </div>

      )


    });

    return <div class="grid-container"> {contentsArray} </div>
  }



  render() {

    return (
      this.isLoading ? <loader-component />
        :
        this.getContentsV2()

    )

  }
}
